import { Box, Tooltip, Typography } from "@mui/material"
import TableView from "../../components/atoms/table";
import { FetchFromBackoffice } from "../../utils/request";
import { useEffect, useState } from "react";
import { DataLoadingText } from "../../components/atoms/text/dataLoadingText";
import { Tag } from "../../components/molecules/tag";
import { useSelector } from "react-redux";
import { RootState } from "../../state/configureStore";
import { RecipeTags } from "./recipeTags";
import { TagDefenition } from "./types";

export type RecipeItem = {
    article_number: string,
    name: string,
    description: string,
    version: string,
    from_version: string,
    tags: TagDefenition[]
}

export const RecipesTable = () => {
    const getRecipes = async (): Promise<RecipeItem[]> => {
        const recipesResult = await FetchFromBackoffice<RecipeItem[]>('recipes')

        // Cast version column to string so that it can be sorted
        const transformedRecipes: RecipeItem[] = recipesResult.map(recipe => ({
            ...recipe,
            version: String(recipe.version) 
        }));

        return transformedRecipes
    }

    const isMobile = useSelector<RootState>(state => state.dimensions.device) === "mobile"
    const [recipes, setRecipes] = useState<RecipeItem[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(false)

    useEffect(() => {
        setIsLoading(true)

        getRecipes().then(result => {
            setRecipes(result)
            setIsLoading(false)
        })
    }, [])

    return (
        isLoading ? (
            <DataLoadingText showSpinner text={'Loading recipes...'} />
        ) :
            recipes.length === 0 ? (
                <Typography>No recipes found. </Typography>
            )
                :
                (
                    <Box>
                        <TableView
                            items={recipes}
                            defaultSortColumn={'article_number'}
                            isClickable={true}
                            //onRowClick={item => navigate(item.articleNo)}
                            columns={[
                                {
                                    Property: "article_number",
                                    Title: 'Article number',
                                },

                                {
                                    Property: "name",
                                    Title: "Name",
                                },

                                {
                                    Property: "description",
                                    Title: "Description",
                                },
                                {
                                    Property: "from_version",
                                    Title: "Required Version",
                                },
                                {
                                    Property: "version",
                                    Title: "Recipe Version",
                                },
                                {
                                Property: "tags",
                                Title: "Required Tags",
                                Sortable: false,
                                Render: (item) =>
                                    <div style={{ display: "flex", flexDirection: "row", gap: 4, minWidth: "220px", maxWidth: !isMobile ? "420px" : "120px", flexWrap: "wrap" }}>

                                    { 
                                        <RecipeTags tags={item.tags} articleNumber={item.article_number} version={item.version} />
                                    }
                                    
                                    </div>
                                },

                            ]}>

                        </TableView>
                    </Box>
                )
    )
}